import React from 'react';
export function UndoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M10 11v4l-6-5 6-5v4h1a9 9 0 019 9h-2a7 7 0 00-7-7h-1z"
  }));
}